import WeightsRow from './WeightsRow.component';

export default WeightsRow;
